/*
 * file: useOnboardingState
 *
 * custom hook that encapsulate states from the onboardingSelectors and from the RTK Query onboarding APIs.
 *
 */
import { onboardingSelectors } from "./onboarding.selectors";
import { useAppState } from "../../store/hooks";
import { onboardingActions } from "./onboarding.slice";

export const useOnboardingState = () => {
  const stateHook = useAppState({
    selectors: onboardingSelectors,
    actions: onboardingActions,
  });

  return stateHook;
};
